import { NotFoundPanel } from "@/components/NotFoundPanel";

export function NotFound() {
  return (
    <div className="min-h-dvh flex items-center justify-center px-6">
      <NotFoundPanel />
    </div>
  );
}
